import { getCurrentInstance } from "vue"
import axios from "axios"
import VueI18n from "vue-i18n"

export async function fetchTranslations(locale: string) {
    try {
        const response = await axios.get(`/v2/site/translations/${locale}`)

        return response.data
    } catch (error) {
        console.error("Error fetching translations:", error)

        return null
    }
}

export const useI18n = (): VueI18n => {
    const instance = getCurrentInstance()

    if (!instance || !instance.proxy.$i18n) {
        throw new Error("I18n is not available in this instance.")
    }

    return instance.proxy.$i18n
}

export const translateForOemToLower = (oem: string, value: string, i18nInstance?: VueI18n) => {
    const i18n = i18nInstance ?? useI18n()
    const i18Lower = i18n.t(value).toLowerCase()
    const translation = `${oem} ${i18Lower}`

    return translation || `${oem} ${value}`
}
